import React, { useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebarMenu } from '@hooks/useSidebarMenu';
import ExpandSideBarItem from '@components/sidebar/ExpandSideBarItem';
import CollapseSideBarItem from '@components/sidebar/CollapseSideBarItem';
import PWAExpandSideBarItem from '@components/sidebar/PWAExpandSideBarItem';
import PWACollapseSideBarItem from '@components/sidebar/PWACollapseSideBarItem';
import SideBarModal from '@components/shared/modals/SideBarModal';
import useIsMobile from '@hooks/useIsMobile';
import useMobileDetect from '@hooks/useMobileDetect';
import { useTranslation } from 'react-i18next';
import { IMAGE_DOMAINS } from '@constants/api';
import { getCurrentYYYYMMDDhhmmss } from '@utils/util';
import AfterLoginView from './AfterLoginView';
import { SidebarWrap } from '@components/sidebar/styles';
import { SWITCH_ROUTES } from '@constants/routes';
import { useGlobalProps } from "@hooks/useGlobalProps";
import { shouldLogoDisplay, groupMenuItems, IS_AGT, IS_ASIA, IS_NEW_AW, shouldDisplayInstallButtonsInSidebar, shouldDisplayLoginButton, shouldPromptPWAInstall } from '@constants/config';

export const Sidebar = (props) => {
    const { setOpenLoginModal, isLogin } = props; //openSideBarModal, onToggleSideBarModal,
    const { isExpand } = useSidebarMenu();
    const { t } = useTranslation();
    const tCommon = t('common', { returnObjects: true });
    const isMobile = useIsMobile();
    const isMobileDevice = useMobileDetect();
    const navigate = useNavigate();
    const location = useLocation();
    const { menuItems, gameDisplaying } = useGlobalProps()

    let jkeyRef = useRef();
    let mRef = useRef();


    useEffect(() => {
        async function fetch() {
            const params = new URLSearchParams(location.search);
            jkeyRef.current = params.get('jkey');
            mRef.current = params.get('m');

        }


        fetch();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const logoImgUrl = isExpand
        ? `${IMAGE_DOMAINS.LOGOS
        }/desktop-logo.png?gettime=${getCurrentYYYYMMDDhhmmss()}`
        : `${IMAGE_DOMAINS.LOGOS
        }/mobile-logo.png?gettime=${getCurrentYYYYMMDDhhmmss()}`;

    // 遊戲開啟時完全不渲染側邊欄，避免在橫向 landscape (viewport > 768px) 下漏出在遊戲畫面左側
    if (gameDisplaying) return null;

    // IS_ASIA 系列不需要側邊欄
    if (IS_ASIA) return null;

    // 所有裝置（含桌面）一律走 SideBarModal，不再使用桌面版固定側邊欄
    return (
        <SideBarModal
            {...props}
            menuItems={menuItems}
            navigate={navigate}
            location={location}
            tCommon={tCommon}
        />
    );

    const showBalance = isExpand && isLogin;
    const displayLoginBtn = isExpand && !isLogin;
    const groupedMenuItems = groupMenuItems(menuItems);

    return (
        <SidebarWrap isExpand={isExpand} isLogin={isLogin} gameDisplaying={gameDisplaying}>
            <div className="logo-wrap">
                {shouldLogoDisplay() && <img alt="logo" src={logoImgUrl} />}
                {!isLogin && (IS_AGT) ? (
                    <button
                        className="login-btn"
                        onClick={() => navigate({
                            pathname: SWITCH_ROUTES.JOIN_US,
                            search: mRef.current ? `?m=${mRef.current}` : '',
                        })}                    >
                        {tCommon['common@join-us'] || 'Join Us'}
                    </button>
                ) : (
                    <>
                        {shouldDisplayLoginButton() && !jkeyRef.current && displayLoginBtn && (
                            <button
                                className="login-btn"
                                onClick={(IS_NEW_AW) ? () => navigate(SWITCH_ROUTES.LOGIN) : () => setOpenLoginModal(true)}
                            >
                                {tCommon['common@login']}
                            </button>
                        )}
                        {shouldDisplayLoginButton() && jkeyRef.current && displayLoginBtn && (
                            <button
                                className="login-btn"
                                onClick={() => {
                                    navigate({
                                        pathname: SWITCH_ROUTES.REGISTER,
                                        search: `?jkey=${jkeyRef.current}`,
                                    });
                                }}
                            >
                                {tCommon['common@register']}
                            </button>
                        )}
                    </>
                )}
                {showBalance && <AfterLoginView />}
            </div>
            <>
                <div className="sidebar-items">
                    {isExpand ? (
                              <>
                              {menuItems.map((m) => (
                                  <ExpandSideBarItem
                                      key={m.menuName}
                                      active={m.path === location.pathname}
                                      currentPath={location.pathname}
                                      {...m}
                                      menuName={`${m.menuNamePrefix
                                          ? `${m.menuNamePrefix} `
                                          : ''
                                          }${tCommon[`sidebar@${m.menuName}`]}`}
                                      navigate={navigate}
                                  />
                              ))}
                              {shouldDisplayInstallButtonsInSidebar() && shouldPromptPWAInstall() && !isLogin && isMobileDevice && (
                                  <PWAExpandSideBarItem
                                      key="pwa-install"
                                      active={SWITCH_ROUTES.PWA_INSTALL === location.pathname}
                                      currentPath={location.pathname}
                                      path={SWITCH_ROUTES.PWA_INSTALL}
                                      menuName={tCommon['sidebar@pwa-install'] || '輕安裝'}
                                      icon="download_action_40x40"
                                      navigate={navigate}
                                  />
                              )}
                              
                          </>  
                    ) : (
                        <>
                            {menuItems.map((m) => (
                                <CollapseSideBarItem
                                    key={m.menuName}
                                    active={m.path === location.pathname}
                                    {...m}
                                    navigate={navigate}
                                />
                            ))}
                            {shouldDisplayInstallButtonsInSidebar() && shouldPromptPWAInstall() && !isLogin && isMobileDevice && (
                                <PWACollapseSideBarItem
                                    key="pwa-install"
                                    active={SWITCH_ROUTES.PWA_INSTALL === location.pathname}
                                    path={SWITCH_ROUTES.PWA_INSTALL}
                                    icon="download_action_40x40"
                                    navigate={navigate}
                                />
                            )}
                        </>
                    )}
                </div>
            </>
        </SidebarWrap>
    );
};

export default Sidebar;
